import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export function Other() {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <p className="font-semibold mb-0">
            What if you have sources that are not in the Guide?
          </p>
        </div>
        <p className="mb-0">
          Use our generic utm parameters to be able to pass through data to your
          dashboard.{" "}
          <GenericExternalLink href="https://docs.northbeam.io/docs/tracking-for-other-platforms#if-your-platform-is-not-in-the-guide-please-use-standard-utm-parameters">
            documentation
          </GenericExternalLink>
        </p>
      </div>
      <ConstructDestinationUrl platform={NorthbeamUtmPlatform.OTHER} />
    </div>
  );
}
